// extracted by mini-css-extract-plugin
export default {"label":"CommissionedLabel_label__5Fred","iconWrapper":"CommissionedLabel_iconWrapper__L7a3C","icon":"CommissionedLabel_icon__i2Sc3"};